import type { GraphDimensions } from '../../playbook-builder.types';
import type { LayoutedNode } from '../get-elements-with-layout/get-elements-with-layout';

interface GraphDimsProps {
  nodes: Pick<LayoutedNode, 'position' | 'width' | 'height'>[];
}

const getGraphDims = ({ nodes }: GraphDimsProps): GraphDimensions => {
  if (nodes.length === 0) {
    return { width: 0, height: 0, originX: 0, originY: 0 };
  }

  const minX = Math.min(...nodes.map(node => node.position.x));
  const maxX = Math.max(...nodes.map(node => node.position.x + node.width));
  const minY = Math.min(...nodes.map(node => node.position.y));
  const maxY = Math.max(...nodes.map(node => node.position.y + node.height));

  const nodeDimension = {
    width: maxX - minX,
    height: maxY - minY,
    originX: minX,
    originY: minY,
  };

  return nodeDimension;
};

export default getGraphDims;
